import React from "react";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Theme } from "@material-ui/core/styles";

import Breakpoints from "common/breakpoints";
import MobileExpiringExamRequirement from "./MobileExpiringExamRequirement";
import ExpirationDays from "./ExpirationDays";

import useStyles from "./styles";

interface IProps {
  horseName: string;
  examType: string;
  reactivationDays: number;
}

const ExpiringExamRequirement = (props: IProps) => {
  const { horseName, examType, reactivationDays } = props;

  const classes = useStyles();
  const matchesDownSX720 = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(Breakpoints.SX_720)
  );

  if (matchesDownSX720) {
    return (
      <MobileExpiringExamRequirement
        examType={examType}
        horseName={horseName}
        reactivationDays={reactivationDays}
      />
    );
  }

  return (
    <div className={classes.root}>
      <div>
        <div className={classes.horseName}>{horseName}</div>
        <div>{examType}</div>
      </div>
      <div className={classes.expirationInfo}>
        <span className={classes.expirationLabel}>Days Until Expiration</span>
        <ExpirationDays reactivationDays={reactivationDays} />
      </div>
    </div>
  );
};

export default React.memo(ExpiringExamRequirement);
